module.exports = __webpack_public_path__ + "static/media/createshop2.9e58ffb0.png";